import { Checkbox } from "components/Atoms/inputs/Checkbox";
import MultiEmailInput from "components/ValidatedFields/MultiEmailInput";

import React from "react";

interface Props {
  value: [string, boolean];
  onChange: (value: [string, boolean]) => void;
  onEsc: () => void;
  onEnter: () => void;
}

export const EmailWithBlacklist = (props: Props) => {

  return <div className="flex-column gap">
    <div>
      <MultiEmailInput
        validatorKey="contactEmail"
        value={props.value[0]}
        onChange={e => props.onChange([e, props.value[1]])}
        onBlur={() => { }}
        onEnter={props.onEnter}
        onEsc={props.onEsc}
        focusOnMount
        maxLength={serverReference.constants.mailAddress.maxEmailLength}
      />
    </div>
    <div>
      <Checkbox
        label={RESX.Company.EmailIsBlacklisted}
        checked={props.value[1]}
        onChange={(_, value) => props.onChange([props.value[0], value])}
      />
    </div>
  </div>

}